import { Component, Input } from '@angular/core';
import { Funds } from '@/lib-backend';
import { PaidCoinIcon } from '@/app/components/icons/paid-coin-icon';
import { FreeCoinIcon } from '@/app/components/icons/free-coin-icon';

@Component({
    selector: 'app-funds-display',
    standalone: true,
    imports: [PaidCoinIcon, FreeCoinIcon],
    template: `
        @if (funds.PaidCredits === 0 && funds.FreeCredits === 0) {
            <span>FREE</span>
        } @else {
            <span class="inline-flex items-center gap-1">
                @if (funds.PaidCredits > 0) {
                    <span class="inline-flex items-center gap-0.5">
                        <app-paid-coin-icon [size]="size" />{{ funds.PaidCredits }}
                    </span>
                }
                @if (funds.FreeCredits > 0) {
                    <span class="inline-flex items-center gap-0.5">
                        <app-free-coin-icon [size]="size" />{{ funds.FreeCredits }}
                    </span>
                }
            </span>
        }
    `,
})
export class FundsDisplay {
    @Input({ required: true }) funds!: Funds;
    @Input() size = 14;
}
